"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const new_peer_connection_1 = require("./new-peer-connection");
class SFUWebRTCManager {
    constructor(sender, onNewRemoteTrack, onConnected, onDisconnected, sdpTransformFn) {
        this.pc = null;
        this.receivedTracks = false;
        this.RTCTracks = [];
        this.connected = true;
        this.sender = sender;
        this.onNewRemoteTrack = onNewRemoteTrack;
        this.onConnected = onConnected;
        this.onDisconnected = onDisconnected;
        this.sdpTransformFn = sdpTransformFn;
        this.MessageTypes = {
            "rtc--call-peer": this.AddAndCallPeer.bind(this),
            "rtc--answer": this.HandleRemoteSDP.bind(this),
            "rtc--offer": this.HandleRemoteSDP.bind(this),
            "rtc--candidate": this.HandleRemoteICECandidate.bind(this),
        };
    }
    Close() {
        var _a;
        (_a = this.pc) === null || _a === void 0 ? void 0 : _a.Close();
        this.pc = null;
    }
    HandleRemoteICECandidate(data) {
        var _a;
        (_a = this.pc) === null || _a === void 0 ? void 0 : _a.ProcessIceSignalIceCandidate(data);
    }
    HandleRemoteSDP(data) {
        var _a;
        (_a = this.pc) === null || _a === void 0 ? void 0 : _a.HandleRemoteDescription(data);
    }
    SetBitrateForVideo(bitrate, ratio) {
        var _a;
        (_a = this.pc) === null || _a === void 0 ? void 0 : _a.changeVideoBitrate(bitrate, ratio);
    }
    SetBitrateForAudio(bitrate) {
        var _a;
        (_a = this.pc) === null || _a === void 0 ? void 0 : _a.changeAudioBitrate(bitrate);
    }
    SetRTCTracks(streams) {
        console.log("setting tracks!", streams);
        const mediaStreams = streams
            .filter((t) => typeof t !== "undefined")
            .map((t) => ({
            label: t.label,
            stream: t.mediaStream,
        }));
        const tracks = mediaStreams.map((t) => {
            if (t.stream && t.stream.getTracks().length > 0) {
                return {
                    track: t.stream.getTracks()[0],
                    id: t.stream.id,
                    stream: t.stream,
                    label: t.label,
                };
            }
            return {
                track: null,
                id: "1",
                stream: t.stream,
                label: t.label,
            };
        });
        this.RTCTracks = tracks;
        this.RTCStream = mediaStreams[0].stream;
        console.log("setting rtc tracks!", this.RTCTracks, this.RTCStream);
        if (this.pc != null)
            this.pc.SetTracks(this.RTCTracks);
    }
    AddAndCallPeer(data) {
        console.log("Calling peer", data);
        this.Close(); // close previous connection
        this.connected = true;
        this.onConnected(true); // connected handler
        console.log("Call peer rtc tracks!", this.RTCTracks, this.RTCStream);
        this.pc = new new_peer_connection_1.PeerConnection({ receiveVideo: true, transformSDP: true }, this.sender, this.onNewRemoteTrack, this.onDisconnected, this.sdpTransformFn);
        this.pc.SetTracks(this.RTCTracks);
    }
}
exports.default = SFUWebRTCManager;
